import { createStore } from 'vuex';
export default createStore({
  state: {
    token: null
  },
  getters: {
    getToken: function getToken(state) {
      return state.token || localStorage.getItem('token') || null;
    }
  },
  mutations: {
    SET_TOKEN: function SET_TOKEN(state, token) {
      localStorage.setItem('token', token);
      state.token = token;
    },
    REMOVE_TOKEN: function REMOVE_TOKEN(state) {
      state.token = null;
      removeToken('token');
    },
    CLEAR_TOKEN: function CLEAR_TOKEN(state) {
      state.token = null;
    }
  },
  actions: {
    setToken: function setToken(_ref, token) {
      var commit = _ref.commit;
      commit('SET_TOKEN', token);
    },
    clearToken: function clearToken(_ref2) {
      var commit = _ref2.commit;
      commit('CLEAR_TOKEN');
    }
  },
  modules: {}
});